import Index from './common/consent/index.vue'

export default {
  path: '/recruiting/consent',
  component: Index,
  meta: {
    noAuth: true,
    isInclude: true,
    titleI18nKey: 'personal.consent.homeMenu.name',
    mobileHomeMenu: {
      redirectPath: '/recruiting/consent',
      iconClass: 'icona-PrivacyPolicy',
      nameI18nKey: 'personal.consent.homeMenu.name',
      descI18nKey: 'personal.consent.homeMenu.desc'
    }
  }
}
